export default __webpack_public_path__ + "static/media/Intrauterine-Insemination-(IUI)-Banner.9b72d09e.jpg";